module.exports = __webpack_public_path__ + "img/startup-school-banner.f37e2429.png";